import {
  GET_HAIR_DIAGNOSIS,
  SAVE_TEMPORARY_DIAGNOSIS_USER,
  SAVE_DIAGNOSIS_USER,
  GET_DIAGNOSIS_USER_PROFILE,
  GET_USER_DIAGNOSIS,
  RESET_USER_DIAGNOSIS,
  MAKE_USER_CURRENT,
  SAVE_NEW_SALON_VISIT,
} from '../constants';
import {
  getContent,
  saveUserInfoToDB,
  getUserDiagnosis,
  getUserDiagnosisByEmail,
  saveNewSalonVisitToDB,
} from '../../services/api';

export const fetchHairDiagnosis = locale => ({
  type: GET_HAIR_DIAGNOSIS,
  payload: getContent({ contentType: 'hairDiagnosis', locale }),
});

export const retrieveDiagnosisProfile = email => ({
  type: GET_DIAGNOSIS_USER_PROFILE,
  payload: getUserDiagnosisByEmail(email),
});

export const saveTemporaryUserInfo = data => ({
  type: SAVE_TEMPORARY_DIAGNOSIS_USER,
  payload: data,
});

export const saveUserInfo = data => ({
  type: SAVE_DIAGNOSIS_USER,
  payload: saveUserInfoToDB(data),
});

export const fetchUserDiagnosis = id => ({
  type: GET_USER_DIAGNOSIS,
  payload: getUserDiagnosis(id),
});
export const fetchSCUserDiagnosis = id => ({
  type: GET_USER_DIAGNOSIS,
  payload: getUserDiagnosis(id),
});

export const resetCurrentDiagnosisUser = () => ({
  type: RESET_USER_DIAGNOSIS,
});

export const makeUserCurrent = id => ({
  type: MAKE_USER_CURRENT,
  payload: id,
});

export const saveNewSalonVisit = profile => ({
  type: SAVE_NEW_SALON_VISIT,
  payload: saveNewSalonVisitToDB(profile),
});



// WEBPACK FOOTER //
// ./src/redux/actions/hairDiagnosis.js